<h1 mat-dialog-title>{{ ("editShifts" | i18n) || "Schichten anpassen" }}</h1>

<!-- Job Type Selector -->
<mat-form-field
  class="light-form-field job-type-selector-dialog"
  data-cy="shift-edit-dialog-job-type-select"
  *ngIf="!(customer$ | async)?.hiddenFields?.jobtype">
  <mat-label>
    {{ ("jobType" | i18n) || "Jobtype" | titlecase }}
  </mat-label>
  <mat-select
    [(ngModel)]="jobType"
    (selectionChange)="onJobTypeChange($event.value)"
    name="dialogJobTypeSelect"
    [attr.data-cy]="'job-type-value-' + jobType">
    <mat-option [value]="undefined">{{ ("all" | i18n) || "Alle" }}</mat-option>
    <!-- Option to clear/select all -->
    <mat-option
      *ngFor="let jobTypeKey of jobTypeEnum | enumToArray"
      [value]="jobTypeEnum[jobTypeKey]"
      [attr.data-cy]="'job-type-select-option-' + jobTypeEnum[jobTypeKey]">
      {{ ("jobTypeEnum." + jobTypeEnum[jobTypeKey] | i18n) || jobTypeKey }}
    </mat-option>
  </mat-select>
</mat-form-field>

<div class="row shifts-wrapper">
  <app-job-shifts
    [(shifts)]="selectedShifts"
    [hasMultipleShifts]="splitShiftsEnabled"
    (hasMultipleShiftsChange)="toggleHasMultipleShifts($event)"
    [availableShifts]="availableShifts"
    [invalid]="!selectedShifts || selectedShifts.length === 0"
    [canEditShifts]="canEditShifts"
    data-cy="shift-edit-dialog-shifts">
  </app-job-shifts>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    class="bordered-button"
    type="button"
    (click)="close()"
    data-cy="shift-edit-dialog-close-button">
    {{ ("close" | i18n) || "Schliessen" }}
  </button>
  <div class="flex-spacer"></div>

  <button
    class="bordered-button"
    type="button"
    mat-button
    (click)="continue()"
    data-cy="shift-edit-dialog-save-button">
    {{ ("save" | i18n) || "Speichern" }}
  </button>
</div>
